import * as React from 'react';
export const IcTerminal = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18 3H6a3 3 0 00-3 3v12a3 3 0 003 3h12a3 3 0 003-3V6a3 3 0 00-3-3zM9.71 9.71l-2 2a1 1 0 01-1.639-.325 1 1 0 01.219-1.095L7.59 9l-1.3-1.29a1.004 1.004 0 011.42-1.42l2 2a1 1 0 010 1.42zM17 12h-4a1 1 0 010-2h4a1 1 0 010 2z'
      fill='currentColor'
    />
  </svg>
);
